import { map } from 'rxjs/operators';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import * as moment from "moment";
import { ModalAddAvenantComponent } from "../../avanant/modal-add-avenant/modal-add-avenant.component";


@Component({
  selector: 'app-modal-add-mass-beneficiaire',
  templateUrl: './modal-add-mass-beneficiaire.component.html',
  styleUrls: ['./modal-add-mass-beneficiaire.component.scss']
})
export class ModalAddMassBeneficiaireComponent implements OnInit {

  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true;
  isAutoFill = false
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "beneficiaire";
  title: string = "bénéficiaire";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];
  itemsRemboursement = [
    { code: "ASSURE", libelle: "ASSURE PRINCIPAL" },
    { code: "CONJOINT", libelle: "CONJOINT" },
    { code: "SOUSCRIPTEUR", libelle: "SOUSCRIPTEUR" },
    { code: "ENFANT", libelle: "ENFANT" },
    { code: "ASCENDANT", libelle: "ASCENDANT" },
  ];

  gender = "F";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeRemboursement: any;
  itemsCourtier: any[];
  itemsCommercial: any;
  itemsSouscripteur: any;
  itemsCategoriePolice: any[];
  currentData: any;
  itemsModeTarification: any;
  itemsReseauDeSoin: any;
  itemsGarant: any;
  itemsAgence: any[];
  itemsStatutPolice: any;
  itemsStatutCollege: any[];
  itemsPolice: any[];
  itemsBareme: any;
  itemsStatut: any[];
  itemsGroupeSanguin: any[];
  itemsNaturePiece: any[];
  isAssurePrincipal: any;
  itemsCollege: any[];
  itemsAvenant: any;
  itemsAssurePrincipaux: any;
  itemAssure: any = {};
  itemsToSaveBenef: any = [];
  isDataValid: boolean = false;
  currentBenef: any;
  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;

    setTimeout(() => {
      console.log("here");

      if (this.currentData) {
        console.log("this.currentData: ", this.currentData)
        this.itemsToSaveBenef = [...this.currentData.data];
        console.log("itemsToSaveBenef: ", this.itemsToSaveBenef)

        this.itemsToSaveBenef.map(its => {
          if (!its.date_entree) {
            its.date_entree = new Date()
          }
        })

        let groupId = 0;
        for (const person of this.itemsToSaveBenef) {
          if (person.statut === 'A') {
            groupId++;
          }
          person.regroupement_famille = groupId || null;
        }
        let values = this.currentData.values
        // console.log("garant_id: ", values.garant_id);
        // console.log("police_id: ", values.garant_id);
        // console.log("college_id: ", values.college_id);
        // console.log("is_lock_header: ", values.is_lock_header);
        if (values) {
          if (values.garant_id) {
            this.itemToSave.garant_id = values.garant_id
            this.getItemsPolice(this.itemToSave.garant_id)
          }
          if (values.police_id) {
            this.itemToSave.police_id = values.police_id
            this.getItemsCollege(this.itemToSave.police_id)
          }
        }
        this.getItemsAvenant()

        console.log("session mode in mass add: ", this.currentData.sessionMode)
      }
    }, 300);
  }
  confirmSaveItemMassData(item) {
    // this.validateForm()
    this.verifyArray();

    if (!this.isDataValid) return;
    console.log('police_id: ', this.itemToSave.police_id)

    if (!this.itemToSave || !this.itemToSave.garant_id) {
      this.utilities.openSwalError('Veuillez renseigner garant')
      return
    }
    if (!this.itemToSave || !this.itemToSave.police_id) {
      this.utilities.openSwalError('Veuillez renseigner police')
      return
    }
    if (!this.itemToSave || !this.itemToSave.college_id) {
      this.utilities.openSwalError('Veuillez renseigner college')
      return
    }
    if (!this.itemToSave || !this.itemToSave.avenant_id) {
      this.utilities.openSwalError('Veuillez renseigner avenant')
      return
    }
    Swal.fire({
      title: this.capitalize(this.title),
      text: "Enregistrement en masse",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.saveItemMassData();
      }
    });
  }

  autoFillFamillyParentMatricule(item) {
    console.log('item: ', item)
    this.itemsToSaveBenef.map(itsb => {
      if (itsb.regroupement_famille == item.regroupement_famille) {
        itsb.matricule_assure = item.matricule_assure;
      }
    })
  }

  uploadBenefImageFile(event: any) {
    console.log("this.currentBenef: ", this.currentBenef);

    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split(".")[0];
      const Tabextension = file.name.split(".");
      const extension = Tabextension[Tabextension.length - 1];

      console.info("fileName", fileName);
      console.info("extension", extension);
      this.imageName = fileName + "." + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // item.image_url = data;
        const fileBase64 = data.split(",")[1];
        let file_data = {
          fileBase64: fileBase64,
          fullImg: data,
          fileName: fileName,
          extension: extension,
          typeDocument: "custom type",
        };
        const index = this.itemsToSaveBenef.findIndex(
          (item) => item.id_ligne === this.currentBenef.id_ligne
        );
        if (index !== -1) {
          this.itemsToSaveBenef[index].file_data = file_data;
        }
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }


  addDocument(event) {
    console.log("addDocument: ", event);
    // this.datasFile = event;
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => {
          this.itemsTypeRemboursement = [];
        }
      );
  }
  getItemsBeneficiaire() {
    // if(itemToSave.garant_id && itemToSave.police_id)
    this.itemToSave.college_id = ''
    this.itemToSave.police_id = ''
    this.itemToSave.garant_id = ''
    this.isAutoFill = false

    if (!this.itemToSave.matricule_assure || this.itemToSave.matricule_assure.toString().length < 8) {
      return
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        // garant_id: this.itemToSave.garant_id,
        matricule: this.itemToSave.matricule_assure,
      },
    };

    this.busyGet = this.restClient
      .post("beneficiaire/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && res["items"].length) {
            this.itemAssure = res["items"][0];
            this.itemToSave.college_id = this.itemAssure.college_id
            this.itemToSave.police_id = this.itemAssure.police_id
            this.itemToSave.garant_id = this.itemAssure.garant_id
            this.itemToSave.nom = this.itemAssure.nom
            this.getItemsGarant()
            this.getItemsPolice(this.itemAssure.garant_id)
            this.getItemsCollege(this.itemAssure.police_id)
            this.isAutoFill = true
          } else {
            this.itemAssure = {};
          }
        },
        (err) => {
          this.itemAssure = {};
        }
      );
  }
  getItemsCourtier() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("courtier/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCourtier = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsCourtier = [];
          }
        },
        (err) => {
          this.itemsCourtier = [];
        }
      );
  }

  getItemsVilite() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("civilite/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCivilite = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsCivilite = [];
          }
        },
        (err) => {
          this.itemsCivilite = [];
        }
      );
  }
  getItemsGenre() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("genre/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGenre = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsGenre = [];
          }
        },
        (err) => {
          this.itemsGenre = [];
        }
      );
  }
  getItemsNaturePiece() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("naturePiece/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsNaturePiece = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsNaturePiece = [];
          }
        },
        (err) => {
          this.itemsNaturePiece = [];
        }
      );
  }

  getItemsStatut() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatut = _.orderBy(res["items"], ["libelle"], ["asc"]);

            this.getItemsAssure();
          } else {
            this.itemsStatut = [];
          }
        },
        (err) => {
          this.itemsStatut = [];
        }
      );
  }

  getItemsGroupeSanguin() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("groupeSanguin/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGroupeSanguin = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsGroupeSanguin = [];
          }
        },
        (err) => {
          this.itemsGroupeSanguin = [];
        }
      );
  }
  getItemsSouscripteur() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsSouscripteur = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsSouscripteur = [];
          }
        },
        (err) => {
          this.itemsSouscripteur = [];
        }
      );
  }
  getItemsCategoriePolice() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("categoriePolice/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCategoriePolice = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCategoriePolice = [];
          }
        },
        (err) => {
          this.itemsCategoriePolice = [];
        }
      );
  }

  getItemsReseauDeSoin() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("reseauDeSoin/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsReseauDeSoin = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsReseauDeSoin = [];
          }
        },
        (err) => {
          this.itemsReseauDeSoin = [];
        }
      );
  }
  getItemsGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarant = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsGarant = [];
          }
        },
        (err) => {
          this.itemsGarant = [];
        }
      );
  }

  getItemsAgence() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("agence/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsAgence = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsAgence = [];
          }
        },
        (err) => {
          this.itemsAgence = [];
        }
      );
  }
  getItemsAvenant() {
    if (!this.itemToSave.police_id) {
      return
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      list_code_type_avenant: ['AVN-INC-BENEF', 'AVN-AFF-NLLE'],
      data: {
        police_id: this.itemToSave.police_id
      },
    };

    this.busyGet = this.restClient
      .post("avenant/getActive", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsAvenant = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsAvenant = [];
          }
        },
        (err) => {
          this.itemsAgence = [];
        }
      );
  }
  getItemsAssure() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        //Later ecrire un service spécial pour get les assuré principaux pour rendre dynamique
        statut_id: this.getStatutAssureId(),
      },
    };

    this.busyGet = this.restClient
      .post("beneficiaire/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsAssurePrincipaux = res["items"];
          } else {
            this.itemsAssurePrincipaux = [];
          }
        },
        (err) => {
          this.itemsAgence = [];
        }
      );
  }

  getStatutAssureId() {
    if (this.itemsStatut && this.itemsStatut.length) {
      let assurePrincipaux = this.itemsStatut.filter(
        (is) => is.codification == "A"
      );
      return assurePrincipaux[0].id;
    }
    return null;
  }
  getItemsStatutCollege() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statutCollege/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatutCollege = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsStatutCollege = [];
          }
        },
        (err) => {
          this.itemsStatutCollege = [];
        }
      );
  }

  getItemsPolice(garant_id) {
    // let current_session = localStorage.getItem('session')
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        // session:this.currentData.sessionMode?current_session:'',
        garant_id: garant_id,
      },
    };

    this.busyGet = this.restClient
      .post("police/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsPolice = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsPolice = [];
          }
        },
        (err) => {
          this.itemsPolice = [];
        }
      );
  }
  getItemsCollege(police_id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        police_id: police_id,
      },
    };

    this.busyGet = this.restClient
      .post("college/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsCollege = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsCollege = [];
          }
        },
        (err) => {
          this.itemsCollege = [];
        }
      );
  }
  getItemsBareme(id) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        garant_id: id,
      },
    };

    this.busyGet = this.restClient
      .post("bareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsBareme = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsBareme = [];
          }
        },
        (err) => {
          this.itemsBareme = [];
        }
      );
  }

  // onSelectDate(event) {
  //   if (event) {
  //     (this.dateNais = moment(event).format("DD/MM/YYYY")),
  //       console.info("dateNais", this.dateNais);
  //   }
  // }

  isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  load_filiale_data() {
    // this.getItems();
    this.getItemsTypeRemboursement();
  }

  onSelectGarant() {
    // this.itemToSave.police_id =''w
    this.itemToSave.police_id = ''
    this.itemToSave.college_id = ''
    this.itemToSave.avenant_id = ''
    this.itemsPolice = []
    this.itemsCollege = []
    this.itemsAvenant = []
    this.getItemsPolice(this.itemToSave.garant_id);
  }

  onSelectPolice() {
    // this.itemToSave.college_id =''
    this.itemToSave.college_id = ''
    this.itemToSave.avenant_id = ''
    this.itemsCollege = []
    this.itemsAvenant = []
    this.getItemsCollege(this.itemToSave.police_id);
    this.getItemsAvenant()
  }
  onSelectCollege() { }

  // on_change_garant(){
  //   if(this.itemsGarant && this.itemsGarant.length){
  //     let current_garant = {...this.itemsGarant.filter(ig=>ig.id == this.itemToSave.garant_id)[0]}
  //     console.log('current_garant: ',current_garant)
  //     if(!this.itemToSave.id){
  //       this.itemToSave.taux_commission_sinistre = current_garant.taux_commission_sinistre
  //       this.itemToSave.forfait_commission_sinistre = current_garant.forfait_commission_sinistre
  //       this.itemToSave.taux_commission_prime = current_garant.taux_commission_prime
  //       this.itemToSave.forfait_commission_prime = current_garant.forfait_commission_prime
  //       this.itemToSave.type_remboursement_id = current_garant.type_remboursement_id
  //       this.itemToSave.seuil_alerte_conso = current_garant.seuil_alerte_conso
  //       this.itemToSave.seuil_suspension_tiers_payant = current_garant.seuil_suspension_tiers_payant
  //       this.itemToSave.assure_remboursement = current_garant.assure_remboursement
  //       this.itemToSave.mode_tarification_id = current_garant.mode_tarification_id
  //       this.itemToSave.mode_reconduction_id = current_garant.mode_reconduction_id
  //       this.itemToSave.mode_fractionnement_id = current_garant.mode_fractionnement_id
  //       this.itemToSave.reseau_de_soin_id = current_garant.reseau_de_soin_id
  //     }
  //   }

  // }

  openModalPrestataireReseau() {
    if (!this.itemToSave.reseau_de_soin_id) return;
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 5458545,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let reseau_id = this.itemToSave.reseau_de_soin_id;
    let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(
      (ird) => ird.id == reseau_id
    )[0].libelle;
    let data = {
      reseau_de_soin_id: reseau_id,
      reseau_de_soin_libelle: reseau_de_soin_libelle,
    };
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => { });
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split(".")[0];
      const Tabextension = file.name.split(".");
      const extension = Tabextension[Tabextension.length - 1];

      console.info("fileName", fileName);
      console.info("extension", extension);
      this.imageName = fileName + "." + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(",")[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: "custom type",
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  handleImageError(item) {
    item.image_url = "assets/images/custom/user-ano.jpeg";
  }

  onSelectStatut() {
    let statutCodification = this.itemsStatut.filter(
      (its) => its.id == this.itemToSave.statut_id
    )[0].codification;
    if (statutCodification == "A") {
      this.isAssurePrincipal = true;
      this.itemToSave.matricule_assure = "";
    }
    else {
      this.isAssurePrincipal = false;
    }
  }

  getAge() {
    if (this.itemToSave.date_naissance) {
      let age = moment().diff(this.itemToSave.date_naissance, "years");
      return age;
    }
    return 0;
  }

  openAddAvenant(data?) {
    let modal: any;
    modal = ModalAddAvenantComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 58,
      class: "modal-width-50",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {
      this.currentPage = 0;
      this.getItemsAvenant();
    });
  }


  saveItemMassData() {
    this.loading = true;
    let itemsToEnregistrer = [...this.itemsToSaveBenef];
    if (itemsToEnregistrer && itemsToEnregistrer.length) {
      itemsToEnregistrer.map((ite) => {
        ite.garant_id = this.itemToSave.garant_id
        ite.police_id = this.itemToSave.police_id
        ite.college_id = this.itemToSave.college_id
        ite.avenant_id = this.itemToSave.avenant_id
        // ite.regroupement_famille =this.itemToSave.regroupement_famille
        ite.filiale_id = this.user.filiale_id
        ite.code = this.generateUniqueString()
        // ite.date_naissance = moment(ite.date_naissance).toDate();

        if (ite.file_data && ite.file_data.fullImg) {
          delete ite.file_data.fullImg;
        }
        if (ite.datasAffection && ite.datasAffection.length) {
          let reduce = []
          ite.datasAffection.map((iada: any) => {
            reduce.push({ id: iada.id })
          })
          ite.datasAffection = reduce
        }
      });
    }

    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      avenant_id: this.itemToSave.avenant_id,
      datas: itemsToEnregistrer,
    };

    this.busySave = this.restClient
      .post("beneficiaire/incorporationEnMasseCreate", request)
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.bsModalRef.hide()

          } else {

            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  verifyArray() {
    // const array = this.itemsToSaveBenef;
    this.isDataValid = true;
    // this.itemsToSaveBenef.map(itsb=>{
    //   itsb.isRowValid =true
    // })

    const requiredKeys = [
      "nom",
      "prenom",
      "statut",
      "date_naissance",
      "genre",
      "statut",
      "regroupement_famille",
      "date_entree"
    ]; // List of keys that should be present and not empty

    for (let i = 0; i < this.itemsToSaveBenef.length; i++) {
      const obj = this.itemsToSaveBenef[i];
      for (let key of requiredKeys) {
        // Check if the key is present and not empty
        if (
          !(key in obj) ||
          obj[key] === "" ||
          obj[key] === null ||
          obj[key] === undefined
        ) {
          this.isDataValid = false;
          // this.itemsToSaveBenef[i]['isRowValid'] = false
          console.log(
            `Object at index ${i} has an empty or missing key: ${key}`
          );
          console.log('itemsToSaveBenef error: ', this.itemsToSaveBenef)
          Swal.fire({
            title: "Informations non valides",
            text: `Veuillez renseigner le champ ${key} à la ligne ${i + 1}`,
            icon: "error",
            confirmButtonColor: "red",
            confirmButtonText: "Ok",
          });

          break; // Exit the inner loop when an empty field is found
        }
      }
    }
  }

  ngOnInit() {
    this.getItemsFiliale();
    this.getItemsTypeRemboursement();
    this.getItemsCourtier();
    this.getItemsStatut();
    this.getItemsSouscripteur();
    this.getItemsCategoriePolice();
    this.getItemsGroupeSanguin();
    this.getItemsReseauDeSoin();
    this.getItemsAgence();
    this.getItemsStatutCollege();
    this.getItemsGarant();
    this.getItemsVilite();
    this.getItemsGenre();
    this.getItemsNaturePiece();
    this.getItemsAvenant();
  }
}
